<template>
    <div class="excessive_buy">
        <div class="excessive_buy_c">
            <div class="navigation">
                <div class="left" @click="goBack"><i class="icon-thin_back"></i></div>
                <div class="content"></div>
            </div>
            <div class="excessive_buy_content">
                <img src="../../../assets/mai.jpg"/>
            </div>
            <div class="excessive_buy_bottom"  @click="buyClick">
                <div class="title">购买课程 >></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "excessivebuy",
        methods: {
            goToBack() {
                this.goBack(this.$router);
            },
            buyClick:function(){
                window.location.href = this.$route.query.buyUrl;
            }
        }
    }
</script>

<style scoped>
    .excessive_buy {
        background-color: #3b9c55;
        position:absolute;
        width:100%;
        height:auto;
        min-height: 100%;
        text-align: center;
    }
    .excessive_buy_c {
        max-width: 590px;
        display: inline-block;
    }
    .navigation {
        width: 100%;
        height: 44px;
        position: fixed;
        background-color: #3b9c55;
    }
    .navigation .left {
        float: left;
        width: 50px;
        height: 100%;
        color: white;
        font-size: 20px;
        text-align: center;
        line-height: 50px;
    }
    .navigation .content {
        float: left;
        height: 100%;
        width: calc(100% - 50px - 15px);
        text-align: center;
        line-height: 44px;
        color: #333333;
        font-size: 18px;
        font-weight: bold;
    }
    .excessive_buy_content {
        margin-top: 64px;
        margin-bottom: 80px;
    }
    .excessive_buy_content img {
        width: calc(100% - 30px);
    }
    .excessive_buy_bottom {
        background-color: #fdb82c;
        position: fixed;
        bottom: 20px;
        width: calc(100% - 40px);
        height: 44px;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        max-width: 400px;
        left: 50%;
        -webkit-transform: translateX(-50%);
    }
    .excessive_buy_bottom .title {
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translateX(-50%) translateY(-50%);
        font-size: 18px;
        font-weight: bold;
        color: white;
    }
</style>
